import AddressFormValidation from './AddressFormValidation'
import InvoiceFormValidation from './InvoiceFormValidation'
import Step2FormValidation from './Step2FormValidation'
import ChangePasswordValidation from './ChangePasswordValidation'
import LoginFormValidation from './LoginFormValidation'
import PasswordResetRequestFormValidation from './PasswordResetRequestFormValidation'
import NewsletterValidation from './NewsletterValidation'
import {ContactFormValidation} from './ContactFormValidation'
import {RegisterFormValidation} from './RegisterFormValidation'
import DeleteAccountFormValidation from './DeleteAccountFormValidation'
import Spinner from '../../Core/Spinner'

const addressForm = new AddressFormValidation();
addressForm.onLoad();
addressForm.onChange();

const invoiceForm = new InvoiceFormValidation();
invoiceForm.createRecaptcha();
invoiceForm.onLoad();
invoiceForm.onChange();
invoiceForm.submit();

const Step2Form = new Step2FormValidation();

const ChangePasswordForm = new ChangePasswordValidation();
ChangePasswordForm.onLoad();
ChangePasswordForm.onChange();

const loginForm = new LoginFormValidation(Spinner);
loginForm.onEnterPressed()
loginForm.onClick()

const passwordResetRequestForm = new PasswordResetRequestFormValidation(Spinner);
passwordResetRequestForm.submit();

const NewsletterForm = new NewsletterValidation();
NewsletterForm.onLoad();
NewsletterForm.onChange();

const DeleteAccountForm = new DeleteAccountFormValidation();
DeleteAccountForm.onLoad();
DeleteAccountForm.onChange();

export default {
    AddressFormValidation,
    InvoiceFormValidation,
    Step2FormValidation,
    ChangePasswordValidation,
    NewsletterValidation,
    loginForm,
    ContactFormValidation,
    RegisterFormValidation,
    DeleteAccountFormValidation
}
import AddressFormValidation from './AddressFormValidation'
import InvoiceFormValidation from './InvoiceFormValidation'
import Step2FormValidation from './Step2FormValidation'
import ChangePasswordValidation from './ChangePasswordValidation'
import LoginFormValidation from './LoginFormValidation'
import PasswordResetRequestFormValidation from './PasswordResetRequestFormValidation'
import NewsletterValidation from './NewsletterValidation'
import {ContactFormValidation} from './ContactFormValidation'
import {RegisterFormValidation} from './RegisterFormValidation'
import DeleteAccountFormValidation from './DeleteAccountFormValidation'
import Spinner from '../../Core/Spinner'

const addressForm = new AddressFormValidation();
addressForm.onLoad();
addressForm.onChange();

const invoiceForm = new InvoiceFormValidation();
invoiceForm.createRecaptcha();
invoiceForm.onLoad();
invoiceForm.onChange();
invoiceForm.submit();

const Step2Form = new Step2FormValidation();

const ChangePasswordForm = new ChangePasswordValidation();
ChangePasswordForm.onLoad();
ChangePasswordForm.onChange();

const loginForm = new LoginFormValidation(Spinner);
loginForm.onEnterPressed()
loginForm.onClick()

const passwordResetRequestForm = new PasswordResetRequestFormValidation(Spinner);
passwordResetRequestForm.submit();

const NewsletterForm = new NewsletterValidation();
NewsletterForm.onLoad();
NewsletterForm.onChange();

const DeleteAccountForm = new DeleteAccountFormValidation();
DeleteAccountForm.onLoad();
DeleteAccountForm.onChange();

export default {
    AddressFormValidation,
    InvoiceFormValidation,
    Step2FormValidation,
    ChangePasswordValidation,
    NewsletterValidation,
    loginForm,
    ContactFormValidation,
    RegisterFormValidation,
    DeleteAccountFormValidation
}
